/* STAMPED LANGUAGE OVERRIDES - MP FINAL NEW SITE 250905 */

(function () {
  // don't run in Theme Editor; quick kill switch = ?no-stamped-override=1
  if (window.Shopify && Shopify.designMode) return;
  if (location.search.indexOf('no-stamped-override=1') !== -1) return;

  var locale = ""; // "fr", "en", etc.
  console.log("Stamped override running. Locale:", locale);

  /* ---------------- Maps: add new lines as you find them ---------------- */
  var FR_MAP = {
    "Give": "",
    "and get": "",
    "Earn points": "Gagnez Points",
    "Redeem": "Réclamez",
    "Your rewards": "Vos Récompenses",
    "Your last rewards": "Vos dernières récompenses",
    "Apply": "Appliquer",
    "Apply Coupon": "Appliquez le Code-Rabais",
    "History": "Historique",
    "Redeem": "Utiliser mes points",
    "Sign in": "Se connecter",
    "Sign up": "S'inscrire",
    "Share via:": "Partagez avec :"
  };

  var EN_MAP = {
    "Offrez un Rabais de 15%": "Offer a 15% discount",
    "Recevez 1000 Points": "and get 1000 Points",
    "Vos Récompenses": "Your Rewards",
    "Vos dernières récompenses": "Your last rewards",
    "Appliquez le Code-Rabais": "Apply Coupon",
    "Historique": "History",
    "Utiliser mes points": "Redeem",
    "Se connecter": "Sign in",
    "S’inscrire": "Sign up",
    "S'inscrire": "Sign up"
  };

  /* ---------------- Helpers ---------------- */
  function replaceInTextNodes(root, map) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (n) {
      var before = n.nodeValue, after = before;
      for (var k in map) if (map.hasOwnProperty(k)) {
        after = after.replace(new RegExp(k, 'gi'), map[k]); // case-insensitive
      }
      if (after !== before) n.nodeValue = after;
    });
  }

  // Referral hard-cleaner (handles &nbsp; and split nodes)
  function cleanReferral() {
    var ref = document.querySelector('#stamped-rewards-widget[data-widget-type="rewards-referral"], .stamped-rewards-widget[data-widget-type="rewards-referral"]');
    if (!ref) return;
    var before = ref.innerHTML;

    if (locale.startsWith('fr')) {
      ref.innerHTML = ref.innerHTML
        .replace(/\bGive[\s\u00a0]*\/?[\s\u00a0]*/gi, '')
        .replace(/[\s\u00a0]*\band get[\s\u00a0]*\/?[\s\u00a0]*/gi, '');
    } else if (locale.startsWith('en')) {
      ref.innerHTML = ref.innerHTML
        .replace(/\bOffrez\b/gi, '')
        .replace(/\bRecevez\b/gi, '')
        .replace(/[\s\u00a0]*\/[\s\u00a0]*/g, ' ');
    }

    if (ref.innerHTML !== before) console.log('[Stamped override] referral cleaned');
  }

  // Last-resort fallback: if FR & we still see “Give/and get”, strip inside any stamped container
  function desperationSweep() {
    if (!locale.startsWith('fr')) return;
    var roots = document.querySelectorAll('#stamped-rewards-widget, .stamped-widget, .stamped-container, #stamped-main-widget');
    roots.forEach(function (root) {
      var html = root.innerHTML;
      var cleaned = html
        .replace(/\bGive[\s\u00a0]*\/?[\s\u00a0]*/gi, '')
        .replace(/[\s\u00a0]*\band get[\s\u00a0]*\/?[\s\u00a0]*/gi, '');
      if (cleaned !== html) {
        root.innerHTML = cleaned;
        console.log('[Stamped override] desperation sweep applied');
      }
    });
  }

  function applyAll() {
    var roots = document.querySelectorAll('#stamped-rewards-widget, .stamped-widget, .stamped-container, #stamped-main-widget');
    roots.forEach(function (r) {
      if (locale.startsWith('fr')) replaceInTextNodes(r, FR_MAP);
      else if (locale.startsWith('en')) replaceInTextNodes(r, EN_MAP);
    });
    cleanReferral();
  }

  // run + observe (throttled)
  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(function(){ applyAll(); }, 500);
    setTimeout(function(){ applyAll(); }, 1500);
    setTimeout(function(){ applyAll(); desperationSweep(); }, 3000); // include fallback on the 3rd pass
  });

  var t;
  new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(function(){ applyAll(); }, 250);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();